import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import type { CandidateShareUserGroup } from '@recruitee/sharing-container-types';
import { AccessKind } from '@recruitee/sharing-container-types';
import { AvatarComponent, DividerComponent, IconComponent } from '@recruitee/user-interface';

@Component({
  selector: 'rt-users-grouped-by-access-kind-list-item',
  imports: [CommonModule, AvatarComponent, TranslatePipe, IconComponent, DividerComponent],
  templateUrl: './users-grouped-by-access-kind-list-item.component.html',
  styleUrl: './users-grouped-by-access-kind-list-item.component.less',
})
export class UsersGroupedByAccessKindListItemComponent {
  protected readonly AccessKind = AccessKind;

  public group = input.required<CandidateShareUserGroup>();
  public isLast = input<boolean>();
  public isExpanded = false;

  public toggle() {
    this.isExpanded = !this.isExpanded;
  }
}
